import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ArticleService {

    private API_URL= environment.API_URL;

    constructor(
        private http : HttpClient
    ) {}

    getLatestArticle() {
        const url = `${this.API_URL}/blog-posts?populate=*&filters[category][name][$eq]=News&sort=publishedAt:DESC&pagination[limit]=5`;
        return this.http.get(url, { headers: {'Authorization': `Bearer ${environment.API_TOKEN}`}});
    }

    getSpotlightArticle() {
        const url = `${this.API_URL}/blog-posts?populate=*&filters[spotlight][$eq]=true&sort=publishedAt:DESC&pagination[limit]=1`;
        return this.http.get(url, { headers: {'Authorization': `Bearer ${environment.API_TOKEN}`}});
    }

}